// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDymfIFpHvb1AlgbNhnka3CkWWCZ7l6Gb4",

  authDomain: "trenerka-psow.firebaseapp.com",

  projectId: "trenerka-psow",

  storageBucket: "trenerka-psow.firebasestorage.app",

  messagingSenderId: "454800163155",

  appId: "1:454800163155:web:b64c3ad6ffbfb59c09e1a6"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
let analytics = null;

function initAnalytics() {
  const consent = localStorage.getItem("cookiesConsent");
  if (consent) {
    try {
      analytics = getAnalytics(app);
    } catch (error) {
      console.warn("Firebase Analytics nie jest dostępne lub wystąpił błąd:", error);
      analytics = null;
    }
  }
}

function getAnalyticsInstance() {
  return analytics;
}
export { initAnalytics, getAnalyticsInstance };
